import { Box } from '@qcx/ui';

export interface BreadcrumbProps {
  children: React.ReactNode;
}

export const Breadcrumb = ({ children }: BreadcrumbProps) => (
  <Box as="nav" css={{ py: '$6' }}>
    <Box
      as="ol"
      css={{
        listStyle: 'none',
        flexRowCenter: true,
        '> li + li': {
          '&:before': {
            content: '/',
            color: '$textMuted',
            d: 'inline-block',
            px: '$2',
            fontSize: '$xs'
          }
        }
      }}
    >
      {children}
    </Box>
  </Box>
);
